// src/components/SurveyDistributionCard.jsx
import React from "react"
import Knob from "../AllCharts/knob/knob"
import { useSelector } from "react-redux"

const SurveyDistributionCard = ({ distribution, onClick, isSelected }) => {
  const sentimentScore = Number(distribution?.avgSentimentScore ?? 0)
  const mode = useSelector(s => s.Layout?.layoutMode)
  const audienceName = distribution?.Audience?.name ?? "Unknown audience"
  const surveyTitle = distribution?.Survey?.title ?? "No survey"

  const knobColor =
    sentimentScore >= 7
      ? "#28a745"
      : sentimentScore >= 4
        ? "#f4a261"
        : "#e63946"

  // inline styles (minimal, sleek)
  const sx = {
    item: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      padding: "10px 14px",
      borderRadius: 10,
      background: `${mode === "dark" ? "#252F40" : "white"}`,
      boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
      cursor: "pointer",
      transition: "background 120ms ease, border-color 120ms ease",
    },
    itemHover: {
      background: mode === "dark" ? "white" : "black",
    },
    accent: {
      width: 4,
      alignSelf: "stretch",
      background: isSelected ? "#2990DF" : "transparent",
      borderRadius: 4,
      marginRight: 10,
    },
    left: {
      display: "flex",
      alignItems: "center",
      minWidth: 0,
      flex: 1,
      gap: 8,
    },
    audience: {
      fontWeight: 600,
      color: mode === "dark" ? "white" : "black",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "45vw",
    },
    dot: {
      color: "#9CA3AF",
    },
    survey: {
      color: mode === "dark" ? "white" : "black",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "45vw",
    },
    right: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      flexShrink: 0,
    },
    score: {
      fontWeight: 700,
      color: mode === "dark" ? "white" : "black",
      fontSize: 14,
      textAlign: "right",
      minWidth: 54,
    },
  }

  const [hover, setHover] = React.useState(false)

  return (
    <div
      className="br"
      role="button"
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ ...sx.item }}
    >
      {/* <div style={sx.accent} /> */}
      <div style={sx.left} title={`${audienceName} • ${surveyTitle}`}>
        <span style={sx.audience}>{audienceName}</span>
        <span style={sx.dot}>•</span>
        <span style={sx.survey}>{surveyTitle}</span>
      </div>

      <div style={sx.right}>
        <Knob
          value={sentimentScore}
          max={10}
          fgColor={knobColor}
          thickness={0.22}
          height={56}
          width={56}
          readOnly
        />
        <div style={sx.score}>{sentimentScore} / 10</div>
      </div>
    </div>
  )
}

export default SurveyDistributionCard
